import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para cualquier hogar?',
    a: 'Sí. Para personas solas, parejas y familias con hijos. Cada tomo tiene variantes de porciones y adaptaciones.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Por email, inmediatamente después del pago. Acceso en menos de 5 minutos en cualquier dispositivo.'
  }, {
    q: '¿Qué lo diferencia de recetas de Instagram?',
    a: 'No es una colección de recetas. Es un sistema completo con planificación semanal, listas de compras, freezer y batch cooking. Está pensado para que la cocina deje de ser un problema para siempre.'
  }, {
    q: '¿Necesito saber cocinar?',
    a: 'No. Todas las recetas tienen pasos simples, tiempos reales y alternativas para cuando falta algún ingrediente.'
  }];
  return <section className="py-20 px-4 bg-brand-darker" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center flex items-center justify-center gap-3" data-id="element-99">
          <span data-id="element-100">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-101">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-102" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-brand-card border border-white/10 rounded-2xl overflow-hidden" data-id="element-103">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-104">
        <span className="font-bold text-lg" data-id="element-105">{question}</span>
        <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-106" />
      </button>
      <AnimatePresence data-id="element-107">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-108">
            <div className="px-6 pb-5 text-gray-400 leading-relaxed" data-id="element-109">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}